function Settings() {
  return <div></div>;
}

export default Settings;
